import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Organizations/hooks/useOrganization.ts
function useOrganization(args, opts = {}) {
	const { data, isCalling } = useRPC("organizations::get-organization-profile::1", args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.organizationId
	});
	return {
		data,
		loading: isCalling
	};
}
export { useOrganization };

//# sourceMappingURL=useOrganization.js.map